import { render } from "./TextContentComponent.vue?vue&type=template&id=92a8f5f4"
import script from "./TextContentComponent.vue?vue&type=script&lang=js"
export * from "./TextContentComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__